<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">Scheduler Actions Required</h3>
    </div>
  </div>

  <div class="row top10">
    <div class="col-xs-12">
      <aims-common-table
        id="sched-action-req-table"
        [dataSource]="schrActionRequired | async"
        [header]="tableHeader"
        [permissions]="tablePermissions | async"
        [pageSize]="15"
        [stickyHeader]="true">
      </aims-common-table>
    </div>
  </div>
</div>
